import React, { FC } from 'react';
import { useTheme } from '@mui/material';
import { useSelector } from 'react-redux';

import { Maintenance503Icon } from 'src/shared/components/icons';
import { getSynerionLogoUrl } from 'src/shared/utils';
import { getCurrentCulture } from 'src/store/localizations/localizations.selectors';

/*
    Notes : Edge cases when the translations api would fail, the following strings are stored at this level.
    If the user's language preference cannot be retrieved as well, then the language is determined using the browser's
    default language.
 */
export const Maintenance503Page: FC = () => {
  const theme = useTheme();
  const currentCulture = useSelector(getCurrentCulture);
  const { title, message } = getLocalizedStrings(currentCulture);

  return (
    <div className="h-100 w-100 d-flex flex-column align-items-center justify-content-between my-4">
      <img alt="synerion-logo" src={getSynerionLogoUrl(theme)} width="140" />
      <div className="w-100 d-flex flex-column align-items-center justify-content-center">
        <Maintenance503Icon />
        <div className="px-3 mt-5 text-center">
          <h1 className="h4 fw-medium">{title}</h1>
          <p className="text-muted my-3" style={{ whiteSpace: 'pre-line' }}>
            {message}
          </p>
        </div>
      </div>
      <div />
    </div>
  );
};

const getLocalizedStrings = (culture: string): { title: string; message: string } => {
  switch (culture.substring(0, 2).toLowerCase()) {
    case 'fr':
      return {
        message:
          'La page que vous recherchez est actuellement en maintenance - \n nous nous préparons à mieux vous servir :)',
        title: 'Un instant!',
      };
    case 'es':
    case 'en':
    default:
      return {
        message:
          "The page you’re looking for is currently under maintenance - \n we're getting prepared to serve you better :)",
        title: 'Hang on!',
      };
  }
};
